/**
 * Ширина открытой панели разбора — CSS-переменная `--video-drawer-w` на <html>.
 * Страницы с сеткой отодвигаются на неё (`--video-drawer-inset`, app-tokens.css):
 * карточки не остаются под панелью. Подписчики узнают о смене до записи — пока
 * страница в прежней раскладке, сетка успевает запомнить, где стояла карточка.
 */
const VARIABLE = '--video-drawer-w';

type Listener = () => void;

const listeners = new Set<Listener>();

/** Вызов перед сменой ширины, раскладка ещё прежняя. Возвращает отписку. */
export function onBeforeDrawerInsetChange(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** `null` — панель закрыта, страница возвращает себе всю ширину. */
export function setDrawerInset(widthPx: number | null): void {
  const root = document.documentElement;
  const next = widthPx === null ? '' : `${widthPx}px`;
  if (root.style.getPropertyValue(VARIABLE) === next) return;

  for (const listener of listeners) listener();
  if (widthPx === null) root.style.removeProperty(VARIABLE);
  else root.style.setProperty(VARIABLE, next);
}
